import React from 'react';

const PENoteView = ({ data }) => {
    const renderSelectedData = (items, path = []) => {
        return items
            .filter((item) => item.isSelected)
            .map((item, index) => {
                const newPath = [...path, item.name];

                if (item.type === 'header') {
                    return (
                        <div key={index} className="mt-2 ms-2">
                            <h6 style={{ fontWeight: 'bold', color: 'gray', fontSize: '14px' }}>{item.name.split("-")[0] || item.name}:</h6>
                            <div className="d-inline">
                                {renderSelectedData(item.hierarchy, newPath)}
                            </div>
                        </div>
                    );
                }

                if (item.type === 'option') {
                    return (
                        <div key={index} className="mt-2">
                            <h6 style={{ fontWeight: 'bold', color: 'gray', fontSize: '14px' }}>{item.name.split("-")[0] || item.name}:</h6>
                            <div className="d-inline">
                                {renderSelectedData(item.hierarchy, newPath)}
                            </div>
                        </div>
                    );
                }

                if (item.type === 'subHeader') {
                    const selectedOptions = item.hierarchy.filter(child => child.type === 'option' && child.isSelected);
                    const hasInputType = selectedOptions.find(opt => opt.hierarchyType === 'input');
                    const selectedSubHeaders = item.hierarchy.filter(child => child.type === 'subHeader' && child.isSelected);

                    if (selectedOptions.length === 0 && selectedSubHeaders.length === 0) {
                        return null;
                    }

                    return (
                        <span key={index} className="d-inline">
                            <span className='ms-2' style={{ fontWeight: '500', color: 'gray', fontSize: '13px' }}>
                                {item.name.split("-")[0] || item.name} :
                            </span>
                            {selectedOptions.length > 0 && (
                                <>
                                    <span className="text-secondary" style={{ fontWeight: '100', marginLeft: '5px', fontSize: '13px' }}>
                                        {selectedOptions.map((opt, idx) => (
                                            <span key={idx}>
                                                {opt.name.split("-")[0] || opt.name}
                                                {idx < selectedOptions.length - 1 ? ', ' : ' ;'}
                                            </span>
                                        ))}
                                        {hasInputType && <span className='ms-2'>Reason: {hasInputType?.inputData}</span>}
                                    </span>

                                </>
                            )}
                            {renderSelectedData(selectedSubHeaders, newPath)}
                        </span>
                    );
                }

                return renderSelectedData(item.hierarchy, newPath);
            });
    };

    return (
        <div className="  rounded p-3" style={{ maxWidth: '100%', overflowX: 'auto', height: '70vh' }}>
            <h5 className="mb-3 position-absolute"> Note</h5>
            <div className="rounded p-2 mt-3" style={{ width: '1900px', overflowX: 'auto' }}>
                {renderSelectedData(data)}
            </div>
        </div>
    );
};

export default PENoteView;
